export function buildSandboxSrcDoc(html: string): string {
  return `<!doctype html>
<html lang="zh-CN">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data: blob:; style-src 'unsafe-inline'; font-src data:; base-uri 'none'; form-action 'none';" />
  <style>
    :root { color-scheme: light; font: 16px/1.65 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; color: #111827; background: #fff; }
    body { margin: 0; padding: 18px; word-break: break-word; }
    img, video { max-width: 100%; height: auto; }
    table { border-collapse: collapse; width: 100%; overflow: auto; }
    td, th { border: 1px solid #d8e0ea; padding: 8px; vertical-align: top; }
    pre, code { white-space: pre-wrap; word-break: break-word; }
    a { color: #2563eb; }
    h1, h2, h3 { scroll-margin-top: 18px; }
  </style>
</head>
<body>${html}</body>
</html>`
}

export function buildInteractiveSandboxSrcDoc(html: string): string {
  const csp = `<meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src 'unsafe-inline'; style-src 'unsafe-inline'; img-src data: blob:; font-src data:; media-src data: blob:; base-uri 'none'; form-action 'none'; connect-src 'none'; frame-src 'none'; object-src 'none';" />`

  if (/<head[\s>]/i.test(html)) {
    return html.replace(/<head([^>]*)>/i, `<head$1>${csp}`)
  }

  return `<!doctype html>
<html lang="zh-CN">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  ${csp}
</head>
<body>${html}</body>
</html>`
}
